import { Box } from '@mui/material'
import { memo } from 'react'
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import { useNavigate } from 'react-router-dom'

export const SideMenuTree = memo(({ items, collapsed = false }) => {
  const key = 1
  const navigate = useNavigate()
  const menuSelectionHandler = path => {
    if (path !== undefined) {
      navigate(path)
    }
  }

  return (
    <>
      <Box
        key={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: collapsed ? '60px' : '300px',
          transition: 'width 0.3s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          height: '100%',
          padding: '2em 0 0 0'
        }}
      >
        <SimpleTreeView>
          {items?.map((mainItem, indx) => {
            return (
              <TreeItem
                itemId={mainItem?.name}
                label={<TreeHeader mainMenuItem={mainItem} />}
                key={key + indx}
                onClick={() => menuSelectionHandler(mainItem?.path)} // ✅ Entire parent row clickable
              >
                 {mainItem?.children?.map((mainMenuItem, indx1) => (
                   <TreeItem
                     itemId={mainMenuItem?.name}
                     label={
                       <span style={{ 
                         opacity: mainMenuItem?.disabled ? 0.5 : 1,
                         cursor: mainMenuItem?.disabled ? 'not-allowed' : 'pointer',
                         color: mainMenuItem?.disabled ? 'grey' : 'inherit'
                       }}>
                         {mainMenuItem?.name}
                       </span>
                     }
                     key={key * indx + indx1}
                     onClick={() => !mainMenuItem?.disabled && menuSelectionHandler(mainMenuItem?.path)}
                     sx={{
                       pointerEvents: mainMenuItem?.disabled ? 'auto' : 'auto', // Still allow hover if needed, or 'none' to block
                       '& .MuiTreeItem-content': {
                          cursor: mainMenuItem?.disabled ? 'not-allowed' : 'pointer',
                       }
                     }}
                   />
                 ))}
              </TreeItem>
            )
          })}
        </SimpleTreeView>
      </Box>
    </>
  )
})
SideMenuTree.displayName = 'SideMenuTree'

export const TreeHeader = memo(({ mainMenuItem }) => {
  const navigate = useNavigate()
  const menuSelectionHandler = path => {
    if (path !== undefined) {
      navigate(path)
    }
  }

  if (mainMenuItem?.children?.length > 0) {
    return (
      <span style={{ display: 'inline-flex', padding: '5px 0 0 0' }}>
        <span>{mainMenuItem?.folderIcon}</span>
        <span style={{ padding: '0 0 0 5px' }}>{mainMenuItem?.name}</span>
      </span>
    )
  }
  return <span>{mainMenuItem?.name}</span>
})
TreeHeader.displayName = 'TreeHeader'

export default SideMenuTree
